import React, { Children } from 'react';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <div className="min-h-screen w-full bg-[#f8f7f4] font-sans text-[#1e293b]" data-id="element-983">
      {/* Top Nav Bar */}
      <header className="bg-[#002868] text-white w-full" data-id="element-984">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-12 flex items-center justify-between" data-id="element-985">
          <a href="/" className="flex items-center gap-2 font-bold text-lg tracking-tight" data-id="element-986">
            <StarIcon className="w-5 h-5 fill-current text-[#b91c1c]" data-id="element-987" />
            <span data-id="element-988">PatriotsInformer</span>
          </a>
        </div>
      </header>

      <div className="bg-white border-b border-gray-200 w-full" data-id="element-989"></div>

      {/* Main Content */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16" data-id="element-990">
        {/* Page Header */}
        <div className="mb-10 space-y-3" data-id="element-991">
          <div className="flex items-center gap-2 text-[#b91c1c]" data-id="element-992">
            <ShieldCheckIcon className="w-6 h-6" data-id="element-993" />
            <span className="text-sm font-bold uppercase tracking-widest text-[#64748b]" data-id="element-994">
              Legal
            </span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-[#0f172a] tracking-tight leading-tight" data-id="element-995">
            Privacy Policy
          </h1>
          <p className="text-[#64748b] text-sm" data-id="element-996">Last Updated: February 2026</p>
          <div className="h-1 w-16 bg-[#b91c1c] rounded" data-id="element-997"></div>
        </div>

        {/* Policy Content */}
        <div className="space-y-10 text-[#334155] leading-relaxed" data-id="element-998">
          <section className="space-y-3" data-id="element-999">
            <p data-id="element-1000">
              PatriotsInformer Media, LLC ("we," "us," or "our") is committed to
              protecting your privacy. This Privacy Policy explains how we
              collect, use, disclose, and safeguard your information when you
              visit our website{' '}
              <strong className="text-[#0f172a]" data-id="element-1001">PatriotsInformer.com</strong>{' '}
              and any related pages or services. Please read this policy
              carefully. If you disagree with its terms, please discontinue use
              of the site.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1002">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1003">
              1. Information We Collect
            </h2>
            <p data-id="element-1004">
              We may collect information about you in a variety of ways. The
              information we may collect includes:
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1005">Personal Data</h3>
            <p data-id="element-1006">
              When you voluntarily submit information through our opt-in forms,
              we may collect personally identifiable information such as your
              name and email address. You are under no obligation to provide us
              with personal information of any kind; however, your refusal to do
              so may prevent you from using certain features of the site.
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1007">Derivative Data</h3>
            <p data-id="element-1008">
              Our servers may automatically collect non-personal information
              when you access the site, such as your IP address, browser type,
              operating system, access times, and the pages you have viewed
              directly before and after accessing the site.
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1009">
              Cookies and Tracking Technologies
            </h3>
            <p data-id="element-1010">
              We may use cookies, web beacons, tracking pixels, and other
              tracking technologies on the site to help customize the site and
              improve your experience. You can instruct your browser to refuse
              all cookies or to indicate when a cookie is being sent. However,
              if you do not accept cookies, you may not be able to use some
              portions of our site.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1011">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1012">
              2. How We Use Your Information
            </h2>
            <p data-id="element-1013">
              Having accurate information about you permits us to provide you
              with a smooth, efficient, and customized experience. Specifically,
              we may use information collected about you to:
            </p>
            <ul className="list-disc list-inside space-y-2 pl-2" data-id="element-1014">
              <li data-id="element-1015">Send you the content, guides, or resources you requested.</li>
              <li data-id="element-1016">
                Send you newsletters, updates, and promotional communications
                (with your consent).
              </li>
              <li data-id="element-1017">Improve our website, products, and services.</li>
              <li data-id="element-1018">
                Monitor and analyze usage and trends to improve your experience.
              </li>
              <li data-id="element-1019">
                Respond to your comments, questions, and customer service
                requests.
              </li>
              <li data-id="element-1020">Comply with applicable legal obligations.</li>
              <li data-id="element-1021">
                Prevent fraudulent transactions and monitor against theft.
              </li>
            </ul>
          </section>

          <section className="space-y-3" data-id="element-1022">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1023">
              3. Email Communications
            </h2>
            <p data-id="element-1024">
              By providing your email address through our opt-in forms, you
              consent to receive email communications from PatriotsInformer
              Media, LLC. These may include newsletters, survival tips, product
              recommendations, and promotional offers.
            </p>
            <p data-id="element-1025">
              You can unsubscribe from our email list at any time by clicking
              the "unsubscribe" link at the bottom of any email we send. Please
              note that you may continue to receive transactional or
              account-related emails even after unsubscribing from promotional
              communications.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1026">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1027">
              4. Disclosure of Your Information
            </h2>
            <p data-id="element-1028">
              We do not sell, trade, or rent your personal information to third
              parties for their marketing purposes. We may share information we
              have collected about you in certain situations:
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1029">Service Providers</h3>
            <p data-id="element-1030">
              We may share your information with third-party vendors and service
              providers that perform services on our behalf, such as email
              delivery (AWeber), analytics, and hosting. These parties are
              contractually obligated to keep your information confidential and
              use it only to provide services to us.
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1031">Legal Requirements</h3>
            <p data-id="element-1032">
              We may disclose your information where required to do so by law or
              in response to valid requests by public authorities (e.g., a court
              or government agency).
            </p>
            <h3 className="font-semibold text-[#0f172a]" data-id="element-1033">Business Transfers</h3>
            <p data-id="element-1034">
              If we are involved in a merger, acquisition, or sale of all or a
              portion of our assets, your information may be transferred as part
              of that transaction.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1035">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1036">
              5. Data Security
            </h2>
            <p data-id="element-1037">
              We implement administrative, technical, and physical security
              measures to help protect your personal information. While we have
              taken reasonable steps to secure the personal information you
              provide to us, please be aware that no security measures are
              perfect or impenetrable, and no method of data transmission can be
              guaranteed against any interception or other type of misuse.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1038">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1039">
              6. Third-Party Websites
            </h2>
            <p data-id="element-1040">
              Our site may contain links to third-party websites and services.
              These third-party sites have separate and independent privacy
              policies. We have no responsibility or liability for the content
              and activities of these linked sites. Nonetheless, we seek to
              protect the integrity of our site and welcome any feedback about
              these sites.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1041">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1042">
              7. Children's Privacy
            </h2>
            <p data-id="element-1043">
              Our website is not directed to children under the age of 13. We do
              not knowingly collect personal information from children under 13.
              If you are a parent or guardian and believe your child has
              provided us with personal information, please contact us so that
              we can delete such information.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1044">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1045">
              8. Your Rights and Choices
            </h2>
            <p data-id="element-1046">
              Depending on your location, you may have certain rights regarding
              your personal information:
            </p>
            <ul className="list-disc list-inside space-y-2 pl-2" data-id="element-1047">
              <li data-id="element-1048">
                <strong data-id="element-1049">Access:</strong> You may request a copy of the personal
                information we hold about you.
              </li>
              <li data-id="element-1050">
                <strong data-id="element-1051">Correction:</strong> You may request that we correct
                inaccurate or incomplete information.
              </li>
              <li data-id="element-1052">
                <strong data-id="element-1053">Deletion:</strong> You may request that we delete your
                personal information, subject to certain exceptions.
              </li>
              <li data-id="element-1054">
                <strong data-id="element-1055">Opt-Out:</strong> You may opt out of receiving marketing
                emails at any time via the unsubscribe link.
              </li>
            </ul>
            <p data-id="element-1056">
              To exercise any of these rights, please contact us using the
              information provided below.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1057">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1058">
              9. Changes to This Privacy Policy
            </h2>
            <p data-id="element-1059">
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by updating the "Last Updated" date at
              the top of this page. You are encouraged to review this Privacy
              Policy periodically to stay informed of updates. Your continued
              use of the site after any changes constitutes your acceptance of
              the new Privacy Policy.
            </p>
          </section>

          <section className="space-y-3" data-id="element-1060">
            <h2 className="text-xl font-bold text-[#0f172a]" data-id="element-1061">10. Contact Us</h2>
            <p data-id="element-1062">
              If you have questions or comments about this Privacy Policy,
              please contact us at:
            </p>
            <div className="bg-white border border-[#e2e8f0] rounded-lg p-6 space-y-2 shadow-sm" data-id="element-1063">
              <p className="font-bold text-[#0f172a]" data-id="element-1064">
                PatriotsInformer Media, LLC
              </p>
              <p data-id="element-1065">
                10160 Highway 242 Ste 800
                <br data-id="element-1066" />
                PMB 1089
                <br data-id="element-1067" />
                Conroe, TX 77385
              </p>
              <p data-id="element-1068">
                <span className="font-semibold text-[#0f172a]" data-id="element-1069">Email: </span>
                <a href="mailto:support@patriotsinformer.com" className="text-[#002868] underline" data-id="element-1070">
                  support@patriotsinformer.com
                </a>
              </p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 mt-12 py-12" data-id="element-1071">
        <div className="max-w-4xl mx-auto px-4 text-center space-y-4" data-id="element-1072">
          <div className="flex items-center justify-center gap-2" data-id="element-1073">
            <div className="relative w-10 h-10" data-id="element-1074">
              <StarIcon className="w-10 h-10 fill-current text-[#002868]" data-id="element-1075" />
              <StarIcon className="w-4 h-4 fill-current text-white absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-1076" />
            </div>
          </div>
          <div className="text-xs text-gray-500 space-y-2 max-w-2xl mx-auto leading-relaxed" data-id="element-1077">
            <p data-id="element-1078">
              © 2018-2026 PatriotsInformer Media, LLC | All Rights Reserved |
              63 N. Burritt - Buffalo, WY 82834 United States
            </p>
            <p className="space-x-2" data-id="element-1079">
              <a href="/privacy-policy" className="underline hover:text-[#002868]" data-id="element-1080">
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}